import { Message, MessageRoleEnum } from '@hello-pimster/pimster-crm-sdk';

export const buildInitialMessage = (content: string): Message => {
    return {
        id: -1,
        role: MessageRoleEnum.Assistant,
        content,
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
    };
};
